<template>
  <div id="app">
    <topHeader v-if="head_nav.length != 0" :info="info" :nav="head_nav" :lang_list="lang_list"></topHeader>
    <router-view />
    <footerView v-if="footer_nav.length != 0" :info="info" :nav="footer_nav" :head_nav="head_nav" :contact_us_info="contact_us_info"></footerView>
  </div>
</template>
<script>
import topHeader from "@/components/header.vue";
import footerView from "@/components/footer.vue";
export default {
  name: "Home",
  components: {
    topHeader,
    footerView,
  },
  data() {
    return {
      lang: 'en',
      info:{},
      head_nav:[],
      footer_nav:[],
      lang_list:[],
      contact_us_info:{}
    }
  },
  computed: {

  },
  created() {
    this.$api.get("api/Common/index", {}).then((res) => {
      this.$store.state.common = res.data;
      this.info = res.data;
      this.head_nav = res.data.header_nav_list;
      this.lang_list = res.data.lang_list;
      this.contact_us_info = res.data.contact_us_info;
      for (let i = 0; i <  res.data.header_nav_list.length; i++) {
        for (let j = 0; j < res.data.footer_nav_list.length; j++) {
          if ( res.data.header_nav_list[i].name == res.data.footer_nav_list[j].name) {
            res.data.footer_nav_list[j].head_nav_index = i;
          }
        }
      }
      const faviconLink = document.querySelector('#favicon');
      faviconLink.href = res.data.web_info.web_favicon_url;
      this.footer_nav = res.data.footer_nav_list
      this.$store.state.contact_us_info = res.data.contact_us_info;
      if(sessionStorage.getItem("video")){
        this.$store.state.video = sessionStorage.getItem("video");
      } else {
        this.$store.state.video = res.data.header_nav_list[0].video_url;
      }
      console.log(111)
      if(sessionStorage.getItem("bannerS")){
        this.$store.state.bannerS = sessionStorage.getItem("bannerS");
      } else {
        if(res.data.header_nav_list[0].image_pc_url){
          this.$store.state.bannerS = res.data.header_nav_list[0].image_pc_url;
        }
      }

      if(sessionStorage.getItem("head_nav_index")){
        this.$store.state.head_nav_index = sessionStorage.getItem("head_nav_index");
      }
    });
  },
  methods:{
    
  }
};
</script>
<style lang="scss">
@font-face {
  font-family: "MSMincho";
  /* Project id 3035872 */
  src: url("./style/MSMincho.TTF") format("truetype");
}

body,
html {
  box-sizing: border-box;
  overflow-x: hidden;
}

.widthBox {
  width: 1400px;
  margin: 0 auto;
}

html,
body,
div,
p,
i,
a,
textarea,input {
  margin: 0;
  padding: 0;
  font-family: "Inter";
  font-size: 12px;
}
.share_content{
    p{
      font-size:1em;
    }
    div{
      font-size:12px;
    }
    p{
      display: block;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
    }
    ul{
      display: block;
      list-style-type: disc;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 40px;
    }
    li{
      list-style:disc;
      color:#666; 
      margin-block-start: 1em;
      margin-block-end: 1em;
    }
}
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}

a {
  color: #666;
  text-decoration: none;
}

.acea-row {
  display: flex;
  flex-wrap: wrap;

  &.row-top {
    align-items: flex-start;
  }

  &.row-middle {
    align-items: center;
  }

  &.row-bottom {
    align-items: flex-end;
  }



  &.row-right {
    justify-content: flex-end;
  }

  &.row-between {
    justify-content: space-between;
  }

  &.row-left {
    justify-content: flex-start;
  }
  &.row-around {
    justify-content: space-around;
  }

  &.row-center {
    justify-content: center;
  }
  &.row-column {
    flex-direction: column;
  }

  &.row-column-between {
    flex-direction: column;
    justify-content: space-between;
  }

  &.row-column-around {
    flex-direction: column;
    justify-content: space-around;
  }

  &.row-center-wrapper {
    align-items: center;
    justify-content: center;
  }

  &.row-between-wrapper {
    align-items: center;
    justify-content: space-between;
  }

  &.row-around-wrapper {
    align-items: center;
    justify-content: space-around;
  }
}

.title {
  font-size: 40px;
  color: #1a1a1a;
  text-align: center;
}

.txt {
  font-size: 20px;
  color: #1a1a1a;
}

.info {
  font-size: 14px;
  color: #4D4D4D;
  // font-weight: 400;
}

.info2 {
  font-size: 12px;
  color: #999999;
  // font-weight: 400;
}


.info3 {
  font-size: 12px;
  color: #666;
  // font-weight: 400;
}

.f-56 {
  font-size: 56px;
}

.f-36 {
  font-size: 36px;
}

.f-32 {
  font-size: 32px;
}

.f-28 {
  font-size: 28px;
}

.f-20 {
  font-size: 20px;
}

.f-16 {
  font-size: 16px;
}

.f-14 {
  font-size: 14px;
}

.f-12 {
  font-size: 12px;
}
.txt_left{
  text-align: left;
}
.txt_center{
  text-align: center;
}
.warn_txt {
  color: #B50900;
}

.warn_bg {
  background: #B50900;
  color: #fff;
}

.warn_border {
  border: 2px solid #B50900;
}

.remind_txt {
  color: #40B4E5;
}

.remind_bg {
  background: #40B4E5;
  color: #fff;
}

.radius-8 {
  border-radius: 8px;
}

.radius-4 {
  border-radius: 4px;
}

.active_txt:hover {
  color: #B50900;
}

.active_bg:hover {
  border-color: #B50900;
}

.active_border:hover {
  border-color: #B50900;
}

.white {
  color: white
}

.icon_16 {
  width: 16px;
  height: 16px;
}

.img100 {
  width: 100%;
  object-fit: cover;
}

.cursor {
  cursor: pointer;
}

.line_Hide_1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.line_Hide_2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.line_Hide_3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
@media screen and(max-width:1400px) {
  .widthBox {
    width: 1200px !important;
    padding: 0 20px;
    box-sizing: border-box;
  }

  // .title {
  //   font-size: 28px;
  //   color: #1a1a1a;
  // }

  // .txt {
  //   font-size: 16px;
  //   color: #1a1a1a;
  // }

  // .info {
  //   font-size: 14px;
  //   color: #4D4D4D;
  //   font-weight: 400;
  // }

  .f-28 {
    font-size: 24px;
  }

  // .f-20 {
  //   font-size: 16px;
  // }

  // .f-16 {
  //   font-size: 14px;
  // }


@media screen and(max-width:1200px) {
  .widthBox {
    width: 1000px !important;
    padding: 0 20px;
    box-sizing: border-box;
  }

  // .title {
  //   font-size: 20px;
  //   color: #1a1a1a;
  // }

  // .txt {
  //   font-size: 14px;
  //   color: #1a1a1a;
  // }

  .f-56 {
    font-size: 48px;
  }

  .f-36 {
    font-size: 30px;
  }

  .f-32 {
    font-size: 26px;
  }

  // .info {
  //   font-size: 12px;
  //   color: #4D4D4D;
  //   font-weight: 400;
  // }
}

@media screen and(max-width:1000px) {
  .widthBox {
    width: 100% !important;
    padding: 0 20px;
    box-sizing: border-box;
  }

  // .title {
  //   font-size: 20px;
  //   color: #1a1a1a;
  // }

  // .txt {
  //   font-size: 14px;
  //   color: #1a1a1a;
  // }

  // .info {
  //   font-size: 12px;
  //   color: #4D4D4D;
  //   font-weight: 400;
  // }
}

@media screen and(max-width:768px) {
  .widthBox {
    width: 100% !important;
  }

  .title {
    font-size: 28px !important;
    color: #1a1a1a;
    text-align: left;
  }

  // .txt {
  //   font-size: 12px;
  //   color: #1a1a1a;
  // }

  // .info {
  //   font-size: 10px;
  // }

  // .info2 {
  //   font-size: 10px;
  // }

  // .info3 {
  //   font-size: 10px;
  // }

  .f-56 {
    font-size: 32px;
  }

  .f-36 {
    font-size: 28px;
  }

  .f-32 {
    font-size: 20px;
  }

  .f-28 {
    font-size: 20px;
  }

  // .f-20 {
  //   font-size: 14px;
  // }

  // .f-16 {
  //   font-size: 12px;
  // }

  // .f-14 {
  //   font-size: 10px;
  // }

  // .f-12 {
  //   font-size: 10px;
  // }
}}
</style>
<style>

.el-pagination.is-background.el-pager li:not(.disabled).active{
  background-color:#B50900;/*进行修改选中项背景和字体*/
  color:#fff;
}

.el-pagination.is-background .el-pager li:hover{
   color: #B50900 !important;/*hover时候的文字颜色*/
 }
 .el-pagination.is-background .el-pager li.active{
  background-color:#B50900 !important;
}
 .el-pagination.is-background .el-pager li.active:hover{
   color: #fff !important;/*hover时候的文字颜色*/
}
</style>